import * as React from "react";
import DataGrid from "../app/grid/DataGrid";
import { Divider } from "antd";
import { TGridAction } from "../app/grid/GridActionsDropdown";
import PortalDocumentsTable from "../../pages/portal/PortalDocumentsTable";
import { TTranslate } from "../../../service/locale/TranslationService";
import { IReportingPeriodApplicantDocument } from "../../../model/document/ReportingPeriodApplicantDocument";

export interface State {}

export interface Props {
  translate: TTranslate;
  forms: any;
  spinnerEnabled?: boolean;
  showFormDetails(id: number): any;
  documents: IReportingPeriodApplicantDocument[];
}

export default class ApplicantRowExpanded extends React.Component<
  Props,
  State
> {
  render() {
    const {
      translate,
      forms,
      spinnerEnabled = false,
      showFormDetails,
      documents
    } = this.props;

    const actions: TGridAction[] = [
      {
        label: translate("portal.forms.show_details"),
        onClick: (record) => (e) => showFormDetails(record.id),
        type: "primary"
      }
    ];
    const formsColumns = [
      { title: translate("portal.forms.name"), dataIndex: "name", key: "name" },
      {
        title: translate("portal.forms.publicationDate"),
        dataIndex: "publicationDate",
        key: "publicationDate",
        sorter: (a, b) =>
          DataGrid.SortHelper.compareDateString(
            a.publicationDate,
            b.publicationDate
          )
      }
    ];

    return (
      <div>
        <Divider orientation="left">
          {translate("portal.reporting_period.forms.title")}
        </Divider>
        <DataGrid
          translate={translate}
          columns={formsColumns}
          dataSource={forms}
          actions={actions}
          loading={spinnerEnabled}
        />
        <Divider orientation="left">
          {translate("portal.reporting_period.documents.title")}
        </Divider>
        <PortalDocumentsTable
          translate={translate}
          documents={documents}
          loading={spinnerEnabled}
        />
      </div>
    );
  }
}
